const mental_questions  = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"F[0].Page_1[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"F[0].Page_1[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"F[0].Page_1[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "EVIDENCE REVIEW",
         number: "0"
      },
      "presidence":"Yes",
      "maxLength":105,
      "radioGroup":"F[0].Page_1[0].RadioButtonList[3]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"F[0].Page_1[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   {
      "question":"Please select the symptoms that apply to the headache pain",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "2",
         title: "SYMPTOMS",
         number: "3A"
      },
      "questions":[
         {
            "main":"Constant head pain",
            "dbqName":"F[0].Page_2[0].Constant[0],F[0].Page_2[0].Yes3[0]",
            "answer":""
         },
         {
            "main":"Pulsating or throbbing head pain",
            "dbqName":"F[0].Page_2[0].Pulsating[0],F[0].Page_2[0].Yes3[0]",
            "answer":""
         },
         {
            "main":"Pain localized to one side of the head",
            "dbqName":"F[0].Page_2[0].PainLocalized[0],F[0].Page_2[0].Yes3[0]",
            "answer":""
         },
         {
            "main":"Pain on both sides of the head",
            "dbqName":"F[0].Page_2[0].PainBoth[0],F[0].Page_2[0].Yes3[0]",
            "answer":""
         },
         {
            "main":"Pain worsens with physical activity",
            "dbqName":"F[0].Page_2[0].PainWorsens[0],F[0].Page_2[0].Yes3[0]",
            "answer":""
         },
         {
            "main":"No Headache or Pain",
            "partialField": true,
            "dbqName":"F[0].Page_2[0].No3[0]",
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"Please select the non-headache symptoms that are related to the headache pain",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "2",
         title: "SYMPTOMS",
         number: "3B"
      },
      "questions":[
         {
            "main":"Nausea",
            "dbqName":"F[0].Page_2[0].Nausea[0],F[0].Page_2[0].Yes4[0]",
            "answer":""
         },
         {
            "main":"Vomiting",
            "dbqName":"F[0].Page_2[0].Vomiting[0],F[0].Page_2[0].Yes4[0]",
            "answer":""
         },
         {
            "main":"Sensitivity to light",
            "dbqName":"F[0].Page_2[0].Sensitivitytolight[0],F[0].Page_2[0].Yes4[0]",
            "answer":""
         },
         {
            "main":"Sensitivity to sound",
            "dbqName":"F[0].Page_2[0].Sensitivitytosound[0],F[0].Page_2[0].Yes4[0]",
            "answer":""
         },
         {
            "main":"Changes in vision (such as scotoma, flashes of light, tunnel vision)",
            "dbqName":"F[0].Page_2[0].ChangesinVision[0],F[0].Page_2[0].Yes4[0]",
            "answer":""
         },
         {
            "main":"Sensory changes (such as feeling of pins and needles in extremities)",
            "dbqName":"F[0].Page_2[0].SensoryChanges[0],F[0].Page_2[0].Yes4[0]",
            "answer":""
         },
         {
            "main":"No Non-Headache symptoms",
            "partialField": true,
            "dbqName":"F[0].Page_2[0].No4[0]",
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"Indicate the duration of Headache/Migraine pain?",
      "sub":"Please indicate how long the veteran's headache or migraine pain typically lasts",
      "type":"radio",
      "show": true,
      "section": {
         page: "3",
         title: "SYMPTOMS",
         number: "3C"
      },
      "questions":[
         {
            "label":"Headache/Migraine pain",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Less than 1 day",
                  "dbqName":"F[0].Page_3[0].B1[0]",
                  "sub":""
               },
               {
                  "main":"1-2 days",
                  "dbqName":"F[0].Page_3[0].B2[0]",
                  "sub":""
               },
               {
                  "main":"More than 2 days",
                  "dbqName":"F[0].Page_3[0].B3[0]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
      ]
   },
   {
      "question":"Indicate the Location of Headache/Migraine pain?",
      "sub":"Please indicate how long the veteran's headache or migraine pain typically lasts",
      "type":"radio",
      "show": true,
      "section": {
         page: "3",
         title: "SYMPTOMS",
         number: "3D"
      },
      "questions":[
         {
            "label":"Headache/Migraine pain",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Right side of head",
                  "dbqName":"F[0].Page_3[0].C1[0]",
                  "sub":""
               },
               {
                  "main":"Left side of head",
                  "dbqName":"F[0].Page_3[0].C2[0]",
                  "sub":""
               },
               {
                  "main":"Both sides of head",
                  "dbqName":"F[0].Page_3[0].C3[0]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
      ]
   },

   {
      "question":"Does ##name## have characteristics prostrating attacks of Migraine/Non-migraine headache pain?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "PROSTRATING ATTACKS OF HEADACHE PAIN",
         number: "4A"
      },
      "presidence":"Yes",
      "ref":1,
      "dbqName_yes":"F[0].Page_3[0].Yes7[0]",
      "dbqName_no":"F[0].Page_3[0].No7[0]",
      "answer":"",
   },
   {
      "question":"Indicate frequency, on average, of prostrating attacks over the last several months",
      "sub":"",
      "type":"radio",
      "show": false,
      "refId":"1",
      "section": {
         page: "3",
         title: "SYMPTOMS",
         number: "4A"
      },
      "questions":[
         {
            "label":"Frequency of Migraine/Non-migraine attacks",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"With less frequent attacks",
                  "dbqName":"F[0].Page_3[0].A1[0]",
                  "sub":""
               },
               {
                  "main":"Once in 2 months",
                  "dbqName":"F[0].Page_3[0].A2[0]",
                  "sub":""
               },
               {
                  "main":"Once every month",
                  "dbqName":"F[0].Page_3[0].A3[0]",
                  "sub":""
               }
            ],
            "answer":"Once every month"
         },
      ]
   },
   {
      "question":"Does ##name## have very prostrating and prolonged attacks of Migraine/Non-migraine pain productive of severe economic inadaptability?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "3",
         title: "PROSTRATING ATTACKS OF HEADACHE PAIN",
         number: "4B"
      },
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"F[0].Page_3[0].Yes8[0]",
      "dbqName_no":"F[0].Page_3[0].No8[0]",
      "answer":"",
   },


   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "maxLength":960,
      "show": true,
      "section": {
         page: "4",
         title: "REMARKS",
         number: "8"
      },
      "options":[],
      "dbqName":"F[0].#subform[3].Page_3[1].Remarks[0]",
      "answer":""
   }
 ]

 export default mental_questions ;
